/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Changelog_Typeinsert2Inputs */

const id_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisipkan`)
};

const ms_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisip`)
};

const da_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indsæt`)
};

const de_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einfügen`)
};

const en_us2_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert`)
};

const es_es2_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar`)
};

const es_mx2_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertar`)
};

const fil_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insert`)
};

const fr_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insertion`)
};

const it_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci`)
};

const hu_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beszúrás`)
};

const nl_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoegen`)
};

const no_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sett inn`)
};

const pl_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wstawienie`)
};

const pt_br2_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir`)
};

const pt_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserir`)
};

const ro_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserare`)
};

const fi_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lisäys`)
};

const sv_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infogning`)
};

const vi_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chèn`)
};

const tr_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ekle`)
};

const cs_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vložení`)
};

const bg_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вмъкване`)
};

const ru_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставка`)
};

const uk_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вставка`)
};

const ar_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إدراج`)
};

const hi_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डालें`)
};

const th_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แทรก`)
};

const ja_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挿入`)
};

const zh_cn2_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入`)
};

const zh_hant1_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`插入`)
};

const ko_offerdetail_changelog_typeinsert2 = /** @type {(inputs: Offerdetail_Changelog_Typeinsert2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`삽입`)
};

/**
* | output |
* | --- |
* | "Insert" |
*
* @param {Offerdetail_Changelog_Typeinsert2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_changelog_typeinsert2 = /** @type {((inputs?: Offerdetail_Changelog_Typeinsert2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Changelog_Typeinsert2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "ms") return ms_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "da") return da_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "de") return de_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "fil") return fil_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "fr") return fr_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "it") return it_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "hu") return hu_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "nl") return nl_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "no") return no_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "pl") return pl_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "pt") return pt_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "ro") return ro_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "fi") return fi_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "sv") return sv_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "vi") return vi_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "tr") return tr_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "cs") return cs_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "bg") return bg_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "ru") return ru_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "uk") return uk_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "ar") return ar_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "hi") return hi_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "th") return th_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "ja") return ja_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_changelog_typeinsert2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_changelog_typeinsert2(inputs)
	return ko_offerdetail_changelog_typeinsert2(inputs)
});
export { offerdetail_changelog_typeinsert2 as "offerDetail.changelog.typeInsert" }